import http from '../plugins/axios'

export const getListParameter = async (params) => {
  try {
    const response = await http.get(`/parameters`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}
export const getDetailParameter = async (parameterId) => {
  try {
    const response = await http.get(`/parameters/${parameterId}`)
    return response.data
  } catch(error) {
    throw error
  }
}

export const addParameter = async (payload) => {
  try {
    const response = await http.post(`/parameters`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const assignOrderParameter = async (payload) => {
  try {
    const response = await http.post(`/parameters/order`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateParameter = async (parameterId, payload) => {
  try {
    const response = await http.patch(`/parameters/${parameterId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteParameter = async (parameterId) => {
  try {
    const response = await http.delete(`/parameters/${parameterId}`)
    return response.data
  } catch(error) {
    throw error
  }
}